import { render, staticRenderFns } from "./NoFavorites.vue?vue&type=template&id=949aa006"
import script from "./NoFavorites.vue?vue&type=script&lang=ts"
export * from "./NoFavorites.vue?vue&type=script&lang=ts"
import style0 from "./NoFavorites.vue?vue&type=style&index=0&id=949aa006&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports